export const environment = {
  name: 'production',
  production: true,
  enableWebGameTracking: true,
  // apiUrl: 'https://api.haibench.ai',
  apiUrl: 'https://api.haibench.ai',
  // apiUrl: 'https://prod-haibench-api.k8s.handball.ai',
};
